import { render } from "./FinanceInvoicesComponent.vue?vue&type=template&id=c2679ace&scoped=true"
import script from "./FinanceInvoicesComponent.vue?vue&type=script&lang=js"
export * from "./FinanceInvoicesComponent.vue?vue&type=script&lang=js"

import "./FinanceInvoicesComponent.vue?vue&type=style&index=0&id=c2679ace&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2679ace"]])

export default __exports__